import { Component, OnInit, ViewChild, AfterContentInit, AfterViewInit } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';

import { ApplicationService } from 'src/app/shared/services/application.service';
import { AppSettings } from '../../../app.constant';
import { Application } from '../../../shared/interface/application';
import { DataSource } from '@angular/cdk/table';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-application-table',
  templateUrl: './application-table.component.html',
  styleUrls: ['./application-table.component.css']
})
export class ApplicationTableComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['ApplicationCode', 'ApplicationDate', 'FirstName', 'LastName', 'Gender', 'MobileNo', 'EmailID', 'PassportNo'];
  // filter values
  filteredValues = { ApplicationCode: '', ApplicationDate: '', FirstName: '', LastName: '', Gender: '', MobileNo: '', EmailID: '', PassportNo: '' }
  filterPredicate: any;


  // filter Form contorls ==========>
  nameFilter = new FormControl();
  applicationcodeFilter = new FormControl();
  mobilenoFilter = new FormControl();
  genderFilter = new FormControl();
  // =================================
  post: any;
  public resultdata: any;
  dataSource;
  application: any;
  errorMessage: String;
  progressBar: boolean = true;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private _applicationservice: ApplicationService) { }

  ngOnInit() {
    // filter by name
    this.nameFilter.valueChanges.subscribe((nameFilterValue) => {
      this.filteredValues['FirstName'] = nameFilterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
    });

    // filter by batch code
    this.applicationcodeFilter.valueChanges.subscribe((batchFilterValue) => {
      this.filteredValues['ApplicationCode'] = batchFilterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
    });

    // filter by Enrolment number
    this.mobilenoFilter.valueChanges.subscribe((enrolmentFilterValue) => {
      this.filteredValues['MobileNo'] = enrolmentFilterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
    });

    // filter by Enrolment number
    this.genderFilter.valueChanges.subscribe((enrolmentFilterValue) => {
      this.filteredValues['Gender'] = enrolmentFilterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
    });

    this.getallStudents();
  }

  ngAfterViewInit() {
    let label = document.getElementsByClassName('mat-form-field-label');
    for (let i = 0; i < label.length; i++) {
      label[i].setAttribute("style", "color:white;");
    }
    let element = document.querySelectorAll('.mat-form-field-infix');
    for (let i = 0; i < element.length; i++) {
      element[i].setAttribute("style", "width:100%; color:#fff;");
    }

    let arrow = document.getElementsByClassName('mat-sort-header-arrow');
    for (let i = 0; i < arrow.length; i++) {
      arrow[i].setAttribute("style", "color:#f5f908")
    }

  }

  getallStudents() {
    this._applicationservice.getAllApplication(AppSettings.API_ENDPOINT + AppSettings.GetAllApplication)
      .subscribe(result => {
        this.resultdata = result;
        this.progressBar = false;
        if (!result) {
          return;
        }

        this.dataSource = new MatTableDataSource<Application>(this.resultdata);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = this.customFilterPredicate();
      });
  }

  // custom table filter function
  customFilterPredicate() {
    const myFilterPredicate = function (data: Application, filter: string): boolean {
      let searchString = JSON.parse(filter);
      console.log(searchString);
      return data.FirstName.toString().trim().toLowerCase().indexOf(searchString.FirstName.toLowerCase()) !== -1 &&
        data.ApplicationCode.toString().trim().toLowerCase().indexOf(searchString.ApplicationCode.toLowerCase()) !== -1 &&
        data.MobileNo.toString().trim().toLowerCase().indexOf(searchString.MobileNo.toLowerCase()) !== -1 &&
        data.Gender.toString().trim().toLowerCase().indexOf(searchString.Gender.toLowerCase()) !== -1;
    }
    return myFilterPredicate;
  }

  getValue(event: any) {
    let value = event.target.value;
    console.log("value", value);
  }

}

